<div class="settings-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="settings-shell__backdrop" aria-label="Close sidebar" (click)="closeMobileSidebar()"></button>
  }

  <aside
    class="settings-shell__sidebar"
    [class.settings-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.settings-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="settings-shell__content" >
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="settings-page">
      <section class="settings-page__hero">
        <div class="settings-page__hero-copy">
          <h2 class="app-title-serif">Settings</h2>
        </div>
      </section>

      <section class="settings-page__panel app-card">
        <div>
          <table class="manage-entity-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Setting Name</th>
                  <th>Description</th>
                  <th>Action</th>
                </tr> 
              </thead>
              <tbody>
                  <tr>
                    <td>1</td>
                    <td> Configuration Portal </td>
                    <td> Global project config </td>
                    <td>
                      <a [routerLink]="['/settings/config']" class="btn btn-link p-0 m-0">Manage</a>
                    </td>
                  </tr>
              </tbody>
            </table>
        </div>
      </section>
    </main>
  </div>
</div>
